export default __webpack_public_path__ + "static/media/What_If_Scenario_Illustration.78196a0a.svg";